import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetails: {},
  guestCount: 1,
  confirmationNos: null,
  checkoutTime: null,
  departuredate: null,
};

const confirmationNoSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    userReservationDetailsConfirmatioNo: (state, action) => {
      state.userDetails = action.payload;
    },
    confNoCountOfTheGuests: (state, action) => {
      state.guestCount = state.guestCount + action.payload;
    },
    resetGuestCount: (state) => {
      state.guestCount = 0;
    },
    setMultiConfirmationNos: (state, action) => {
      state.confirmationNos = action.payload;
    },
    setCheckoutTime: (state, action) => {
      state.checkoutTime = action.payload;
    },
    resetCheckoutTime: (state) => {
      state.checkoutTime = null;
    },
    setDepartureDate: (state, action) => {
      state.departuredate = action.payload;
    },
  },
});

export const getCheckoutTime = (state) => 
  state.confirmation.checkoutTime;

export const getDepartureDate = (state) => 
  state.confirmation.departuredate;

export const getconfirmationnumberData = (state) =>
  state.confirmation.userDetails;

export const getConfNoCurrentCountOfGuest = (state) =>
  state.confirmation.guestCount;

export const getMultiConfirmationNos = (state) =>
  state.confirmation.confirmationNos;

export const {
  userReservationDetailsConfirmatioNo,
  confNoCountOfTheGuests,
  resetGuestCount,
  setMultiConfirmationNos,
  setCheckoutTime,
  resetCheckoutTime,
  setDepartureDate,
} = confirmationNoSlice.actions;

export default confirmationNoSlice.reducer;
